import React from 'react';

interface ViewerLoadingOverlayProps {
  sceneName: string;
  description?: string;
  thumbnail?: string;
  progress: number;
  status: string;
}

const ViewerLoadingOverlay: React.FC<ViewerLoadingOverlayProps> = ({
  sceneName,
  description,
  thumbnail,
  progress,
  status,
}) => {
  const displayProgress = Math.max(0, Math.min(100, Math.round(progress)));
  const bodyText = description || status;

  return (
    <div className="fixed inset-0 z-[9999] bg-black pointer-events-none">
      {thumbnail && (
        <img
          src={thumbnail}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/80 to-black/90" />

      <div className="absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/2 w-[32rem] max-w-[92%]">
        <div className="p-[1.5px] rounded-3xl bg-gradient-to-br from-white/20 via-neutral-800 to-transparent shadow-2xl">
          <aside className="relative rounded-3xl bg-black/90 backdrop-blur-xl border border-white/10 overflow-hidden">
            <div className="px-6 pt-5 pb-3 border-b border-white/10">
              <h2 className="text-white text-xl font-semibold tracking-tight truncate">
                {sceneName || 'Loading Scene'}
              </h2>
            </div>

            <div className="px-6 py-4 space-y-5">
              <div className="max-h-40 overflow-y-auto pr-1">
                <p
                  className="text-white/90 text-[0.95rem] leading-6 whitespace-pre-wrap break-words"
                  style={{ fontFamily: "'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif" }}
                >
                  {bodyText}
                </p>
                {bodyText !== status && (
                  <p className="mt-2 text-white/60 text-sm">{status}</p>
                )}
              </div>

              <div className="space-y-3">
                <div className="relative w-full h-3.5 rounded-full bg-white/10 overflow-hidden">
                  <div
                    className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#0CB4E4] to-[#0CB4E4]/85 transition-all duration-300 ease-out"
                    style={{ width: `${displayProgress}%` }}
                  />
                  <div className="absolute inset-0 grid place-items-center">
                    <span className="text-xs font-medium text-white/90 drop-shadow">
                      {displayProgress}% Complete
                    </span>
                  </div>
                </div>

              </div>
            </div>

          </aside>
        </div>
      </div>
    </div>
  );
};

export default ViewerLoadingOverlay;
